(function() {


/*

document.querySelectorAll('.swiper').forEach((el, i) => {
  console.log(i, el, el.swiper, el.swiper?.params);
});

 setTimeout(() => {
  const container = document.querySelector('.section--featured-collection .swiper');

  if (!container) return;

  // Si déjà initialisé → on le détruit
  if (container.swiper) {
    container.swiper.destroy(true, true);
  }

  // On relance un swiper clean
  new Swiper(container, {
    slidesPerView: 3,
    loop: false,
    breakpoints: {
      1024: {
        slidesPerView: 3
      },
      768: {
        slidesPerView: 2
      },
      0: {
        slidesPerView: 1.65
      }
    }
  });

}, 300);
*/

})();

(function () {
  function relabelAndBindReviews() {
    document.querySelectorAll('.jdgm-rev-widg__title').forEach(function (el) {
      el.textContent = "Livre d'or";
    });

    var target = document.getElementById('judgeme_product_reviews');
    if (!target) return;
    var trigger = document.querySelector('.jdgm-prev-badge');
    if (!trigger || trigger.dataset.maScrollBound) return;
    trigger.dataset.maScrollBound = '1';
    trigger.style.cursor = 'pointer';
    trigger.addEventListener('click', function () {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', relabelAndBindReviews);
  } else {
    relabelAndBindReviews();
  }

  var relabelTimer = setInterval(function () {
    var titleEl = document.querySelector('.jdgm-rev-widg__title');
    if (titleEl && titleEl.textContent !== "Livre d'or") {
      titleEl.textContent = "Livre d'or";
    }
  }, 1000);
  window.setTimeout(function () { clearInterval(relabelTimer); }, 15000);
})();
